import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

export const helpers = createMultiStyleConfigHelpers([
  'cancellationFeesAndPoliciesContainer',
  'policiesContainer',
  'policyLink',
])

export const CancellationPolicyModal = helpers.defineMultiStyleConfig({
  baseStyle: {
    cancellationFeesAndPoliciesContainer: {},
    policiesContainer: {
      flexDirection: 'column',
      marginTop: 2,
    },
    policyLink: {
      marginBottom: 2,
    },
  },
})
